/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PartialSurvey } from '../models/PartialSurvey';
import { HttpFile } from '../http/http';

export class PartialUserSurvey {
    'id': number;
    'survey': PartialSurvey;
    'hasStarted'?: boolean;
    'dtAnswered': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "survey",
            "baseName": "survey",
            "type": "PartialSurvey",
            "format": ""
        },
        {
            "name": "hasStarted",
            "baseName": "hasStarted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dtAnswered",
            "baseName": "dtAnswered",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return PartialUserSurvey.attributeTypeMap;
    }

    public constructor() {
    }
}

